












































































































































































































































































































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { MailtoFailureHandler, TextOutput } from '~/mixins';
import PaymentPicker from '~/components/Wallet/PaymentPicker.vue';
import DropSchedule from '~/components/Store/DropSchedule.vue';
import {
  IGameItemForSaleByGala,
  IGameItemProductPrice,
  IPurchaseAgreement,
} from '~/store/games/types';
import LegalAgreements, {
  ILegalAgreementsPayload,
  defaultLegalAgreementsPayload,
} from '~/components/LegalAgreements/LegalAgreements.vue';
import AgreementStatement from '../LegalAgreements/AgreementStatement.vue';
import AgreementDialog from '../LegalAgreements/AgreementDialog.vue';
import IsRestrictedBlock from './IsRestrictedBlock.vue';
import HonorNotice from '~/components/GalaHonor/HonorNotice.vue';
import { ERedeemingActions } from '~/types/honor';
import OddsTable from '~/components/Games/Items/OddsTable.vue';
import DottedBorderBox from '~/components/UIComponents/DottedBorderBox.vue';

@Component({
  computed: {
    ERedeemingActions() {
      return ERedeemingActions;
    },
  },
  components: {
    HonorNotice,
    LegalAgreements,
    PaymentPicker,
    DropSchedule,
    AgreementStatement,
    AgreementDialog,
    IsRestrictedBlock,
    DottedBorderBox,
    OddsTable,
  },
})
export default class CheckoutPurchaseControls extends Mixins(
  MailtoFailureHandler,
  TextOutput,
) {
  @Prop(Object) item!: IGameItemForSaleByGala;
  @Prop(String) buyNowButtonText!: string;
  @Prop(Object) selectedPrice!: IGameItemProductPrice & { imageUrl?: string };
  @Prop(Number) quantity!: number;
  @Prop(Number) calculatedPrice!: number;
  @Prop(Number) discount!: number;
  @Prop(Boolean) hasWallets!: boolean;
  @Prop(Function) handlePaymentMethodSelect!: (
    price: IGameItemProductPrice,
  ) => void;
  @Prop(Function) handleContinueToBuy!: () => void;
  @Prop(Function) handleDiscountCode!: (discountCode: string) => void;
  @Prop(Function) removeDiscount!: () => void;
  @Prop(Boolean) soldOut!: boolean;
  @Prop(Boolean) continueButtonsDisabled!: boolean;
  @Prop(Boolean) showQuantitySelector!: boolean;
  @Prop(Boolean) isRestricted!: boolean;
  @Prop(Boolean) isRestrictionsServiceInitialized!: boolean;
  @Prop(String) disqualifiedMessage!: string;
  @Prop(Boolean) shouldAllowDiscountCodes!: boolean;
  @Prop(String) submittedDiscountCode!: string;
  @Prop(String) appliedDiscountCode!: string;
  @Prop(String) incorrectDiscountCodeMessage!: string;
  @Prop(Boolean) isDiscountLoading!: boolean;

  @Prop(Array)
  agreements!: IPurchaseAgreement[];
  @State(profile => profile.user.loggedIn, { namespace: 'profile' })
  loggedIn!: boolean;
  legalAgreementsPayload: ILegalAgreementsPayload = defaultLegalAgreementsPayload;
  discountCode = '';

  get agreementsSatisfied() {
    return (this.localAgreements || []).every(agreement => agreement.checked);
  }

  localAgreements = this.agreements ?? [];

  contactToPurchaseEmail = 'auctions@gala.games';

  get smallPriceText() {
    return this.discount && this.$vuetify.breakpoint.xs;
  }

  get coinIcon() {
    return (
      this.selectedPrice.imageUrl ||
      (this.selectedPrice.symbol
        ? require(`@/assets/logos/${this.selectedPrice.symbol
            .replace(/\[ETH\]|\[GC\]/g, '')
            .replace('-STRIPE', '')}-icon.png`)
        : '')
    );
  }

  get maxQuantity() {
    // Quick fix to show unlimited quantity for Spider Tanks upgrade components
    if (
      this.item.game === 'Spider Tanks' &&
      ['Component', 'Arachnium', 'Drop Pods'].includes(this.item.category ?? '')
    ) {
      return '∞';
    }

    return this.item.maxQuantityPerOrder &&
      this.item.maxQuantityPerOrder < this.item.qtyLeft
      ? this.item.maxQuantityPerOrder
      : this.formattedQuantity(this.item.qtyLeft);
  }

  formattedQuantity(quantity: number) {
    return this.$numeral(quantity, '0,0');
  }

  handleContinueToBuyClick() {
    if (!this.continueButtonsDisabled) {
      if (this.selectedPrice.creditCard) {
        // This may still be needed with a separate credit card provider, right now it is not needed with moonpay
        // this.selectedCard = this.selectedCard ?? this.creditCards[0];
        // this.showCreditCardPrompt = true;
        this.handleContinueToBuy();
      } else {
        this.handleContinueToBuy();
      }
    }
  }

  applyDiscountCode() {
    this.$emit('handleDiscountCode', this.discountCode);
  }

  removeDiscountCode() {
    this.$emit('removeDiscount');
  }

  @Watch('submittedDiscountCode')
  onCurrentDiscountCodeChange(submittedDiscountCode: any) {
    if (!submittedDiscountCode) {
      this.discountCode = '';
    }
  }
}
